import { render, staticRenderFns } from "./ItemCirculo.vue?vue&type=template&id=b038e6aa"
import script from "./ItemCirculo.vue?vue&type=script&lang=ts"
export * from "./ItemCirculo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports